export const legacySalesStatisticsRows = [
  { office: 'Mock 지점 01', total: 480000, pay1: 280000, pay2: 200000 },
  { office: 'Mock 지점 02', total: 360000, pay1: 160000, pay2: 200000 },
]
